import { ITitleAccordionLeaf, IItem, TitleAccordionLeafProps } from './types';
import { Content } from '@prismicio/client';

export const mapTitleAccordionLeaf = ({
  prismicContent,
}: {
  prismicContent: TitleAccordionLeafProps['slice'];
}): ITitleAccordionLeaf => {
  const items: IItem[] = prismicContent.items.map(
    (item: Content.TitleAccordionLeafSliceDefaultItem) => {
      return {
        text: item.text,
        title: item.title as string,
      };
    },
  );

  const titleAccordionLeaf: ITitleAccordionLeaf = {
    ...prismicContent.primary,
    items,
  };

  return titleAccordionLeaf;
};
